import { ImportDataSchema, ImportLayerDataSchema, LayerDefinitionDc } from "@evergis/api";

export type SchemaParsed = Omit<LayerDefinitionDc, "attributes"> &
  Pick<ImportLayerDataSchema, "firstRow"> & {
    coordinateFields: string[];
    sourceName: string;
    fileType: string;
    objectCount: number;
    schemaAttributes: LayerDefinitionDc["attributes"];
    children: ImportLayerDataSchema[];
  };

export function parseSchema(schema: ImportDataSchema): SchemaParsed {
  if (!schema?.layers || !schema.layers[0]) return {} as SchemaParsed;

  const layer = schema && schema.layers[0];
  const fileType = schema && schema.type;
  const { layerDefinition, name: sourceName, objectCount, children, firstRow, coordinateFields } = layer;
  const { geometryType, geometryAttribute, attributes, idAttribute, titleAttribute, spatialReference } =
    layerDefinition || {};

  return {
    coordinateFields,
    geometryType,
    sourceName,
    fileType,
    objectCount,
    schemaAttributes: attributes,
    geometryAttribute,
    titleAttribute,
    spatialReference,
    idAttribute,
    children,
    firstRow,
  };
}

export function parseKmlSchema(schema: ImportDataSchema): SchemaParsed[] {
  if (!schema?.layers) return [];

  const fileType = schema && schema.type;

  return schema.layers.map(layer => {
    const { layerDefinition, name: sourceName, objectCount, children, firstRow, coordinateFields } = layer;
    const { geometryType, geometryAttribute, attributes, idAttribute, titleAttribute, spatialReference } =
      layerDefinition || {};

    return {
      coordinateFields,
      geometryType,
      sourceName,
      fileType,
      objectCount,
      schemaAttributes: attributes,
      geometryAttribute,
      titleAttribute,
      spatialReference,
      idAttribute,
      children,
      firstRow,
    };
  });
}

export function parseGdbSchema(schema: ImportDataSchema): SchemaParsed[] {
  if (!schema?.layers) return [];

  return schema.layers.map(({ layerDefinition, name: sourceName, objectCount, firstRow, coordinateFields }) => {
    const { geometryType, geometryAttribute, attributes, idAttribute, titleAttribute, spatialReference } =
      layerDefinition || {};

    return {
      coordinateFields,
      geometryType,
      sourceName,
      fileType: schema.type,
      objectCount,
      schemaAttributes: attributes,
      geometryAttribute,
      titleAttribute,
      spatialReference,
      idAttribute,
      children: schema.layers,
      firstRow,
    };
  });
}
